import type { Tour } from '../tour-types';

/**
 * The Overview tab of a survey (`?screen=overview`), where a draft lands. It is read-only
 * apart from the sentiment switch; everything else is changed in the builder. Edit and
 * Start sit in the header, which is rendered in a desktop and a mobile row; each step finds
 * whichever is shown.
 */
export const surveyOverviewTour: Tour = {
  key: 'surveys.overview',
  // 2: Start and end now put the survey on the site at once (PER-332), so that step is shown again.
  version: 2,
  routes: ['/surveys/:id'],
  screen: 'overview',
  steps: [
    {
      anchor: 'survey-overview-questions',
      placement: 'right',
      title: 'Questions',
      body: "What the survey asks, in order, with each question's kind and whether an answer is required. To change them, use Edit.",
    },
    {
      anchor: 'survey-overview-preview',
      placement: 'left',
      title: 'What visitors see',
      body: 'A close likeness of the widget, in its own colours and wording. The real one is drawn on your site.',
    },
    {
      anchor: 'survey-overview-delivery',
      placement: 'left',
      title: 'Delivery',
      body: 'Where the survey appears, what triggers it, and how often a visitor who dismisses it is asked again. Answering stops it for that visitor for good.',
    },
    {
      anchor: 'survey-overview-sentiment',
      placement: 'left',
      requires: 'surveys:manage',
      title: 'Sentiment analysis',
      body: 'Classifies each written comment as positive, neutral or negative, and spends AI credits to do it. The estimate under the switch says roughly how many a month.',
    },
    {
      anchor: 'survey-overview-edit',
      placement: 'bottom',
      requires: 'surveys:manage',
      title: 'Edit',
      body: 'Opens the builder for the questions, trigger and theme. While the survey runs, changed questions cannot be saved, so the answers already collected still match them.',
    },
    {
      anchor: 'survey-overview-start',
      placement: 'bottom',
      requires: 'surveys:manage',
      since: 2,
      title: 'Start and end',
      body: 'Start puts the survey on your site straight away and begins collecting responses. End takes it off and keeps every response.',
    },
  ],
};
